var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Map } from 'immutable';
import { Icon } from "../../UI";
import Doc from "../../Library/components/Doc";
import DropdownList from 'react-widgets/lib/DropdownList';
import * as actions from "../actions/actions";
import HubRelationshipMetadata from "./HubRelationshipMetadata";

class LeftRelationship extends Component {
  static renderFigure() {
    return /*#__PURE__*/(
      _jsx("div", { className: "hubRelationship" }, "figure", /*#__PURE__*/
      _jsx("figure", {})));


  }

  constructor(props) {
    super(props);
    this.toggelRemoveLeftRelationship = this.props.toggelRemoveLeftRelationship.bind(
    null,
    props.index);

    this.onClick = this.onClick.bind(this);
  }

  onClick(_e, entity) {
    this.props.selectConnection(entity);
  }

  renderTrashButton(hub) {
    return (
      this.props.editing && /*#__PURE__*/
      _jsx("div", { className: "removeHub" }, "toggelRemoveLeftRelationship", /*#__PURE__*/
      _jsx("button", { onClick: this.toggelRemoveLeftRelationship, className: "relationships-icon" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: !hub.get('deleted') ? 'trash-alt' : 'undo' }))));




  }

  renderRelationship() {
    const { parentEntity, hub, search, editing, relationTypes, index } = this.props;
    const relationship = hub.get('leftRelationship');
    const targetReference = relationship.get('range') ? relationship : null;
    return /*#__PURE__*/(
      _jsx("div", {

        className: `leftRelationshipType ${hub.get('deleted') ? 'deleted' : ''}` }, "leftRelationshipType",

      !editing && hub.getIn(['leftRelationship', 'template']) && /*#__PURE__*/
      _jsx("div", { className: "rw-dropdown-list rw-widget" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "rw-widget-input rw-widget-picker rw-widget-container no-edit" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "rw-input rw-dropdown-list-input no-edit" }, void 0,

      relationTypes.find((r) => r._id === hub.getIn(['leftRelationship', 'template'])).
      name))),





      editing && /*#__PURE__*/
      _jsx(DropdownList, {
        valueField: "_id",
        textField: "name",
        data: relationTypes,
        value: hub.getIn(['leftRelationship', 'template']),
        filter: "contains",
        onChange: this.props.updateLeftRelationshipType.bind(null, index) }), /*#__PURE__*/


      _jsx("div", {
        className: `leftDocument ${
        !hub.getIn(['leftRelationship', 'template']) && !editing ?
        'docWithoutRelationshipType' :
        ''
        }` }, void 0, /*#__PURE__*/

      _jsx(Doc, {
        className: "item-collapsed",
        doc: parentEntity,
        searchParams: search,
        onClick: this.onClick,
        targetReference: targetReference })), /*#__PURE__*/


      _jsx(HubRelationshipMetadata, { relationship: hub.get('leftRelationship') })));


  }

  render() {
    const { hub, index, parentEntity } = this.props;
    if (!parentEntity.get('sharedId')) {
      return false;
    }
    return /*#__PURE__*/(
      React.createElement(React.Fragment, null,
      this.renderTrashButton(hub, index),
      this.renderRelationship(),
      LeftRelationship.renderFigure()));


  }
}













function mapStateToProps(state) {
  const { relationships } = state;
  return {
    parentEntity: relationships.list.entity,
    search: relationships.list.sort,
    editing: relationships.hubActions.get('editing'),
    relationTypes: actions.selectRelationTypes(state)
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
  {
    selectConnection: actions.selectConnection,
    updateLeftRelationshipType: actions.updateLeftRelationshipType,
    toggelRemoveLeftRelationship: actions.toggelRemoveLeftRelationship
  },
  dispatch);

}

export { LeftRelationship, mapStateToProps };
export default connect(mapStateToProps, mapDispatchToProps)(LeftRelationship);